import styled from 'styled-components'

export const StepsWrapper = styled.div`
  width: 100%;
`
